<template>
  <TwnMainLayout>
    <TwnMultiColumnLayout>
      <template #sidebar>
        <template v-if="!isFullscreen">
          <TwnFocusSidebar />
        </template>
      </template>
      <!-- Page content will be rendered here -->
      <TwnPageContainer>
        <slot />
      </TwnPageContainer>
    </TwnMultiColumnLayout>
    <TwnToast />
    <!-- Enable multiline messages in confirmation dialogs using \n -->
    <TwnConfirmDialog />
    <!-- Global command palette (opened via sidebar search icon or Cmd/Ctrl+K) -->
    <CommandPaletteDialog />
    <!-- PWA Components -->
    <LazyTwnNetworkStatusIndicator />
    <LazyVueQueryDevtools v-if="showDevtools" />
  </TwnMainLayout>
</template>

<script lang="ts" setup>
import { useToast } from 'primevue'
import { defineAsyncComponent } from 'vue'

import TwnConfirmDialog from '@/components/atoms/prime/confirm-dialog/twn-confirm-dialog/TwnConfirmDialog.vue'
import TwnToast from '@/components/atoms/prime/toast/twn-toast/TwnToast.vue'
import TwnPageContainer from '@/components/templates/scaffolds/twn-page-container/TwnPageContainer.vue'
import { useBarcodeAutoForward } from '@/composables/use-barcode-scanner/useBarcodeAutoForward'
import { provideFullscreen } from '@/composables/use-fullscreen/useFullscreen'
import TwnFocusSidebar from '@/domains/admin-panel/components/organisms/menu/twn-focus-sidebar/TwnFocusSidebar.vue'
import TwnMainLayout from '@/domains/admin-panel/components/templates/twn-main-layout/TwnMainLayout.vue'
import TwnMultiColumnLayout from '@/domains/admin-panel/components/templates/twn-multi-column-layout/TwnMultiColumnLayout.vue'
import { useAppearanceClass } from '@/domains/admin-panel/composables/use-appearance/useAppearance'
import CommandPaletteDialog from '@/domains/command-center/components/organisms/command-palette-dialog/CommandPaletteDialog.vue'
import { useToastStore } from '@/domains/notifications/store/use-toast-store/useToastStore.ts'

const isFullscreen = provideFullscreen()
// System, Light or Dark (beta), unless Twine has dark mode off (DEC-2026-060).
useAppearanceClass()

const isDev = import.meta.env.DEV
const showDevtools = isDev && import.meta.env.VITE_FRONTEND_DEBUG === 'true'

const LazyVueQueryDevtools = showDevtools
  ? defineAsyncComponent(() => import('@tanstack/vue-query-devtools').then(m => m.VueQueryDevtools))
  : undefined

// PWA Components - lazy loaded for performance
const LazyTwnNetworkStatusIndicator = defineAsyncComponent(
  () => import('@/domains/pwa/components/atoms/twn-network-status-indicator/TwnNetworkStatusIndicator.vue')
)

useBarcodeAutoForward()

const toastService = useToast()

const toastStore = useToastStore()
toastStore.setService(toastService)
</script>
